/* eslint-disable no-unused-vars */
export enum StatisticsConst {
    GET_STATISTICS = 'GET_STATISTICS',
    SET_STATISTICS = 'SET_STATISTICS',
}